import { EmptyState } from '@app/components/base/EmptyState';
import { Page } from '@app/components/page/Page';
import { ViewErrorActions } from '@mi-front/ui';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import { defineMessage, FormattedMessage, useIntl } from 'react-intl';

const stationNotFoundTitle = defineMessage({
  id: 'common.stationNotFound.text',
  defaultMessage: 'Emisora no encontrada',
});

const stationNotFoundHelp = defineMessage({
  id: 'common.stationNotFound.help',
  defaultMessage: 'Puede que no exista o que no tengas acceso a ella.',
});

/**
 * Shown when a station route points to a slug that does not resolve to an accessible station.
 * Shares the layout and recovery actions of the generic not-found states.
 */
export function StationNotFoundPage() {
  const { $t } = useIntl();

  return (
    <Page htmlTitle={$t(stationNotFoundTitle)}>
      <Page.Content>
        <EmptyState
          icon={SearchOffOutlinedIcon}
          message={<FormattedMessage {...stationNotFoundTitle} />}
          help={<FormattedMessage {...stationNotFoundHelp} />}
          action={<ViewErrorActions kind="notFound" />}
        />
      </Page.Content>
    </Page>
  );
}
